export default "__VITE_ASSET__DoTjIOKO__"